/**
 * 注册vue全局插件
 */
import axios, { AxiosInstance, AxiosResponse } from "axios";
import Qs from "qs";
import signObject from "./getSign";
import { getCookies } from "./util";
import Vue from "vue";

let ZWZT_CODE = getCookies().zwzt_code ? getCookies().zwzt_code : "";

interface Ajax {
  formAjax: AxiosInstance;
  formatForm: (T: any) => any;
  ajax: AxiosInstance;
  jsonAjax: AxiosInstance;
  fileDownloadAjax: AxiosInstance;
}

const Ajax: Ajax = Object.create(null);

// 不分环境(只有dev 和 build)，根据域名动态分配url
let ajaxUrl: string = location.origin;

// 定义头部添加参数
const signHandle = (config: any): any => {
  if (!navigator.onLine) {
    // Vue.prototype.$toast("网络异常");
    return;
  }

  let [sign, timeStamp] = signObject.getSign(
    (config.method === "get" ? config.params : config.data) || ""
  );
  config.headers.sign = config.headers.sign ? config.headers.sign : sign;
  config.headers.timeStamp = config.headers.timeStamp ? config.headers.timeStamp : timeStamp;
  config.headers.userId = config.headers.userId ? config.headers.userId : ZWZT_CODE;
 
  return config;
};

// 定义登录超时函数
const errHandle = (res: any): Promise<any> => {
  if (res.data.status !== 200) {
    // 不是200时，弹出提示信息
    return Promise.reject(res);
  } else {
    return Promise.resolve(res.data);
  }
};
const resHandle = (response: any): Promise<AxiosResponse | any> => {
  // 中间统一处理错误
  return new Promise((resolve, reject) => {
    errHandle(response)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
        // err && Vue.prototype.$toast(`${err.data.msg}`);
      });
  });
};
// 文件提交ajax (file upload)
Ajax.formAjax = axios.create({
  baseURL: ajaxUrl,
  headers: { "Content-Type": false },
  withCredentials: true
});
// 文件提交需要表单对象
Ajax.formatForm = (data: any): object => {
  let formData = new FormData();
  Object.keys(data).map(item => {
    formData.append(item, data[item]);
  });
  return formData;
};
// 普通请求
Ajax.ajax = axios.create({
  baseURL: ajaxUrl,
  headers: {
    "Content-Type": "application/x-www-form-urlencoded"
  },
  // axios默认传送json，需要传送form data需要qs解析
  transformRequest: [data => Qs.stringify(data)],
  responseType: "json",
  withCredentials: true
});

// json请求(payload,适用于不需要把value转为字符串的)
Ajax.jsonAjax = axios.create({
  baseURL: ajaxUrl,
  headers: {
    "Content-Type": "application/json"
  },
  responseType: "json",
  withCredentials: true
});

// file -> blob
Ajax.fileDownloadAjax = axios.create({
  baseURL: ajaxUrl,
  responseType: "blob",
  withCredentials: true
});

// 请求与回应处理
Ajax.ajax.interceptors.request.use(config => signHandle(config));
Ajax.ajax.interceptors.response.use(res => resHandle(res));

Ajax.formAjax.interceptors.request.use(config => signHandle(config));
Ajax.formAjax.interceptors.response.use(res => resHandle(res));

Ajax.fileDownloadAjax.interceptors.request.use(config => signHandle(config));

Ajax.jsonAjax.interceptors.request.use(config => signHandle(config));
Ajax.jsonAjax.interceptors.response.use(res => resHandle(res));

export default Ajax;
